import {
  get,
  error,
} from '@/api/common.js'

function getInfoDesc(path, that) {
  get(path).then(function(Response) {
    var temp = "";
    if (Response.data.type == 1) {
      that.content = Response.data.content;
    } else {
      temp = Response.data.content.replace(/\b/g, "&nbsp;");
      that.content = "<p>" + temp.replace(/\n/g, "</p><p>") + "</p>"
    }
  }, function(Response) {
    error(Response);
  });
}

export {
  getInfoDesc,
}



// WEBPACK FOOTER //
// ./src/api/InfoDesc.js